<script lang="ts" setup>
  import type { ComplaintAndRefundAddress, Refund, RefundItem } from '@storefront/resources';

  interface Props {
    refund: Refund;
    refundReturnAddress: ComplaintAndRefundAddress;
    items: RefundItem[];
  }

  defineProps<Props>();
</script>
<template>
  <main id="main" class="refund container">
    <RefundDetailsView v-bind="$props" showHeader />
  </main>

  <RouterView />
</template>

<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .refund {
    padding: 2rem 0;
    min-height: calc(100dvh - 198px);
  }
</style>